import InvalidLink from './invalidLink.container'

export default InvalidLink